import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const NotFound: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <header>
        <h1>404 - {t('notFound', 'title')}</h1>
      </header>
      <main>
        <div className="post-content">
          <p>{t('notFound', 'message')}</p>
          <p dangerouslySetInnerHTML={{ __html: t('notFound', 'returnText') }} />
          <p>
            {t('notFound', 'contactText')} <a href="https://github.com/panwor">{t('notFound', 'contactLink')}</a>.
          </p>
        </div>
      </main>
    </>
  );
};

export default NotFound;